// src/auth/authConfig.js

export const AUTH_MODES = Object.freeze({
  BYPASS: "bypass",
  DEMO: "demo",
  KEYCLOAK: "keycloak",
});

// legacy support
export const AUTH_BYPASS = process.env.REACT_APP_MOCK_AUTH === "true";

const DEFAULT_DEMO_USERNAME = "User";
const DEFAULT_DEMO_PASSWORD = "12345";

// flag: bypass | demo | keycloak
export function getAuthMode() {
  const explicit = (process.env.REACT_APP_AUTH_MODE || "").trim().toLowerCase();

  if (Object.values(AUTH_MODES).includes(explicit)) {
    return explicit;
  }

  return AUTH_BYPASS ? AUTH_MODES.BYPASS : AUTH_MODES.KEYCLOAK;
}

export function getDemoAuthEnv() {
  return {
    username:
      (process.env.REACT_APP_DEMO_USERNAME || "").trim() ||
      DEFAULT_DEMO_USERNAME,
    password: process.env.REACT_APP_DEMO_PASSWORD || DEFAULT_DEMO_PASSWORD,
  };
}

export function validateDemoCredentials({ username, password }) {
  const demo = getDemoAuthEnv();

  return (
    String(username || "").trim() === demo.username &&
    String(password || "") === demo.password
  );
}

export function getKeycloakEnv() {
  return {
    url: process.env.REACT_APP_KEYCLOAK_URL,
    realm: process.env.REACT_APP_KEYCLOAK_REALM,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  };
}

export function assertKeycloakEnv(env) {
  const missing = Object.entries(env)
    .filter(([, v]) => !v || String(v).trim() === "")
    .map(([k]) => k);

  if (missing.length) {
    throw new Error(
      `[Auth] Keycloak mode enabled but missing env: ${missing.join(", ")}`
    );
  }
}
